import React, { useState } from 'react';
import { Button, MenuItem } from 'react-bootstrap';
import axios from 'axios';

import routes from 'app/routes';

export default function BookOfBusinessReportButton() {
  const [loading, setLoading] = useState(false);

  const sendReport = () => {
    setLoading(true);

    axios
      .get(routes.api.enterprises.book_of_business_report)
      .then((_resp) => {
        swal({
          title: '',
          text: 'Book of Business Report will be updated soon. Please, open Google Sheet and check the update in a couple of minutes.',
        });
        setLoading(false);
      });
  };

  return (
    <MenuItem
      onClick={sendReport}
    >
      Book of Business Report
    </MenuItem>
  );
}
